import { fetchData } from '@umu/umu-fetch';
import API from '../../path';
interface IPermissionSettingParams {
    id: string; // 导航id
    se_id: string; // use id
    obj_type: string; // 权限类型// https://yapi.umu.work/project/46/interface/api/326
}
enum PermissionSettingPageType {
    USE_PERMISSION,
}

interface IPermissionRes {
    permission_option: string[];
    selected_option: string;
}

const getPermissionList = (params = {}): Promise<{ list: string[]; selected: string }> => {
    return fetchData(API.GET_PERMISSION_OPTION, params, { silent: true }).then(
        (res: IResponse<IPermissionRes>) => {
            const { permission_option = [], selected_option = '' } = res?.data || {};
            return {
                list: permission_option,
                selected: selected_option,
            };
        },
        () => {
            return {
                list: [],
            };
        },
    );
};
export { PermissionSettingPageType, IPermissionSettingParams, getPermissionList };
